document.addEventListener("DOMContentLoaded", function() {
  // Select the h1 element with the specified class
  var pageTitle = document.querySelector("h1.colleciton__page-title.page-title");

  // Select the #main-title div
  var mainTitleDiv = document.querySelector("#main-title");

  // Check if both elements exist before moving
  if (pageTitle && mainTitleDiv) {
    // Move the h1 element into the #main-title div
    mainTitleDiv.appendChild(pageTitle);
  }
});
